module.exports = __webpack_public_path__ + "img/img-2.e69ba326.gif";